import { tv } from 'tailwind-variants';
import { disabledStyles } from '../../styles/disabledStyles.esm.js';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const selectableContainerStyles = tv({
    slots: {
        base: `
      iris:group
      iris:flex
      iris:w-full
      iris:cursor-pointer
      iris:self-start
      iris:rounded-(--comp-size-radius-selectable-container)
      iris:border-(length:--comp-size-border-selectable-container)
      iris:border-(--comp-color-border-selectable-container-default-rest)
      iris:bg-(--comp-color-background-selectable-container-default-rest)
      iris:px-(--comp-space-padding-selectable-container-horizontal)
      iris:py-(--comp-space-padding-selectable-container-vertical)
      iris:transition-all
      iris:duration-(--comp-motion-duration-selectable-container)
      iris:ease-(--comp-motion-easing-selectable-container)
    `,
        inputColumn: `
      iris:mr-(--comp-space-gap-check-radio)
      iris:flex
      iris:min-h-(--base-space-px-24)
      iris:flex-shrink-0
      iris:items-center
      iris:self-start
    `,
        contentColumn: `
      iris:flex-grow
      iris:transition-all
      iris:duration-(--comp-motion-duration-selectable-container)
      iris:ease-(--comp-motion-easing-selectable-container)
    `,
        slotWrapper: "iris:w-full",
        labelWrapper: `
      iris:flex
      iris:h-(size:--comp-size-height-check-radio-control)
      iris:min-h-(--base-space-px-24)
      iris:items-center
    `,
        label: `
      iris:block
      iris:text-left
      iris:font-(family-name:--comp-type-font-selectable-container-label)
      iris:text-(length:--comp-type-size-selectable-container-label)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-selectable-container-secondary-label)!
      iris:tracking-(--comp-type-tracking-selectable-container-label)
      iris:text-(--comp-color-content-selectable-container-label-default-rest)
    `,
        secondaryLabel: `
      iris:block
      iris:text-left
      iris:font-(family-name:--comp-type-font-selectable-container-secondary-label)
      iris:text-(length:--comp-type-size-selectable-container-secondary-label)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-selectable-container-label)!
      iris:tracking-(--comp-type-tracking-selectable-container-secondary-label)
      iris:text-(--comp-color-content-selectable-container-secondary-label-default-rest)
    `,
        actionColumn: `
      iris:min-h-(--base-space-px-24)
      iris:flex-shrink-0
    `,
    },
    variants: {
        inverse: {
            true: {
                base: `
          iris:border-(--comp-color-border-selectable-container-inverse-rest)
          iris:bg-(--comp-color-background-selectable-container-inverse-rest)
          ${focusStyles.inverse}
        `,
                label: "iris:text-(--comp-color-content-selectable-container-label-inverse-rest)",
                secondaryLabel: `
          iris:text-(--comp-color-content-selectable-container-secondary-label-inverse-rest)
          iris:group-data-[state=checked]:text-(--comp-color-content-selectable-container-secondary-label-inverse-selected)
        `,
            },
            false: {
                base: `
          ${focusStyles.default}
        `,
                label: "iris:text-(--comp-color-content-selectable-container-label-default-rest)",
                secondaryLabel: "iris:text-(--comp-color-content-selectable-container-secondary-label-default-rest)",
            },
        },
        disabled: {
            true: {
                base: `
          iris:border-(--comp-color-border-selectable-container-default-disabled)
          iris:bg-(--comp-color-background-selectable-container-default-disabled)
          ${disabledStyles}
        `,
                label: "iris:text-(--comp-color-content-selectable-container-label-default-disabled)",
                secondaryLabel: "iris:text-(--comp-color-content-selectable-container-secondary-label-default-disabled)",
            },
            false: {},
        },
    },
    compoundVariants: [
        {
            inverse: true,
            disabled: true,
            class: {
                base: `
          iris:border-(--comp-color-border-selectable-container-inverse-disabled)
          iris:bg-(--comp-color-background-selectable-container-inverse-disabled)
        `,
                label: "iris:text-(--comp-color-content-selectable-container-label-inverse-disabled)",
                secondaryLabel: "iris:text-(--comp-color-content-selectable-container-secondary-label-inverse-disabled)",
            },
        },
        {
            inverse: false,
            disabled: false,
            class: {
                base: `
          iris:hover:border-(--comp-color-border-selectable-container-default-hover)
          iris:hover:bg-(--comp-color-background-selectable-container-default-hover)
          iris:data-[state=checked]:border-(--comp-color-border-selectable-container-default-selected)
          iris:data-[state=checked]:bg-(--comp-color-background-selectable-container-default-selected)
        `,
                label: `
          iris:group-hover:text-(--comp-color-content-selectable-container-label-default-hover)
          iris:group-data-[state=checked]:text-(--comp-color-content-selectable-container-label-default-selected)
        `,
                secondaryLabel: `
          iris:group-hover:text-(--comp-color-content-selectable-container-secondary-label-default-hover)
          iris:group-data-[state=checked]:text-(--comp-color-content-selectable-container-secondary-label-default-selected)
        `,
            },
        },
        {
            inverse: true,
            disabled: false,
            class: {
                base: `
          iris:hover:border-(--comp-color-border-selectable-container-inverse-hover)
          iris:hover:bg-(--comp-color-background-selectable-container-inverse-hover)
          iris:data-[state=checked]:border-(--comp-color-border-selectable-container-inverse-selected)
          iris:data-[state=checked]:bg-(--comp-color-background-selectable-container-inverse-selected)
        `,
                label: `
          iris:group-hover:text-(--comp-color-content-selectable-container-label-inverse-hover)
          iris:group-data-[state=checked]:text-(--comp-color-content-selectable-container-label-inverse-selected)
        `,
                secondaryLabel: `
          iris:group-hover:text-(--comp-color-content-selectable-container-secondary-label-inverse-hover)
          iris:group-data-[state=checked]:text-(--comp-color-content-selectable-container-secondary-label-inverse-selected)
        `,
            },
        },
    ],
});

export { selectableContainerStyles as default };
